<template>
  <Chart type="line" :height="height" :data="data" :options="options" />
</template>

<script>
import { defineComponent, computed } from 'vue'
import moment from 'moment-timezone'
export default defineComponent({
  props: {
    height: {
      type: Number,
      default: 0
    },
    results: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const data = computed(() => {
      return {
        labels: props.results
          .filter((data) => data.cardiaca || data.diastolica || data.sistolica)
          .map((result) => moment.utc(result.day).format('DD-MM-YY')),
        datasets: [
          {
            data: props.results
              .map((result) => Number(result.cardiaca) || 0)
              .filter((data) => data),
            backgroundColor: 'transparent',
            borderColor: '#5E5D5E',
            tension: 0.4,
            pointBackgroundColor: '#5E5D5E',
            pointRadius: 5
          },
          {
            data: props.results
              .map((result) => Number(result.diastolica) || 0)
              .filter((data) => data),
            backgroundColor: 'transparent',
            borderColor: '#F27100',
            tension: 0.4,
            pointBackgroundColor: '#F27100',
            pointRadius: 5
          },
          {
            data: props.results
              .map((result) => Number(result.sistolica) || 0)
              .filter((data) => data),
            backgroundColor: 'transparent',
            borderColor: '#00A1FF',
            tension: 0.4,
            pointBackgroundColor: '#00A1FF',
            pointRadius: 5
          }
        ]
      }
    })
    const options = computed(() => {
      return {
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: true
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: true
              },
              ticks: {
                suggestedMin: 0,
                beginAtZero: 0,
                fontSize: '12',
                fontColor: '#777777'
              }
            }
          ]
        }
      }
    })

    return {
      data,
      options
    }
  }
})
</script>
